import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/login.vue'
import Register from './views/register.vue'
import Quartier from './views/quartier.vue'

import AdminBoard from './views/admin/adminboard.vue'
import AdminGroups from './views/admin/admingroups.vue'

import CreateUser from './views/admin/createUser.vue'
import Vouchers from './views/admin/vouchers.vue'
import CreateSurvey from './views/admin/createSurvey.vue'
import CreateRoom from './views/admin/createRoom.vue'
import AdminAnnouncements from './views/admin/announcements.vue'
import AdminUser from './views/admin/user.vue'
import CreateRessources from './views/admin/createRessource.vue'

import User from './views/users/profile.vue'
import MessageCreate from './components/messageCreate.vue'
import Inbox from './views/users/inbox.vue'
import Dashboard from './views/users/dashboard.vue'
import Devices from './views/users/devices.vue'
import Surveys from './views/users/surveys.vue'
import Events from './views/users/events.vue'
import Calendar from './views/users/calendar.vue'
import Sales from './views/users/sales.vue'
import Groups from './views/users/groups.vue'
import Map from './views/users/map.vue'
import MeetingPoint from './views/users/meetingpoint.vue'
import Ressources from './views/users/ressources.vue'
import Highscore from './views/users/highscore.vue'

import Feedback from './views/users/feedback.vue'
import OldDevices from './views/users/devicesold.vue'


Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior() {
        return { x: 0, y: 0 };
    },
    routes: [{
            path: '/',
            name: 'home',
            component: Dashboard
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
        {
            path: '/register',
            name: 'register',
            component: Register
        },
        {
            path: '/user/:id',
            name: 'user',
            component: User
        },
        {
            path: '/surveys/',
            name: 'surveys',
            component: Surveys
        },
        {
            path: '/admin/user/create',
            name: 'createUser',
            component: CreateUser
        },
        {
            path: '/admin/vouchers',
            name: 'vouchers',
            component: Vouchers
        },
        {
            path: '/message/create/:toUser',
            name: 'messageCreate',
            component: MessageCreate
        },
        {
            path: '/message/create/',
            name: 'messageCreateWithTitle',
            component: MessageCreate,
            props: true,
        },
        {
            path: '/message/inbox',
            name: 'inbox',
            component: Inbox
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard
        },
        {
            path: '/feedback',
            name: 'feedback',
            component: Feedback
        },
        {
            path: '/map',
            name: 'map',
            component: Map
        },
        {
            path: '/quartier',
            name: 'quartier',
            component: Quartier
        },
        {
            path: '/devices',
            name: 'devices',
            component: Devices,
            props: true,
        },
        {
            path: '/groups',
            name: 'groups',
            component: Groups
        },
        {
            path: '/events',
            name: 'events',
            props: true,
            component: Events
        },
        {
            path: '/calendar',
            name: 'calendar',
            component: Calendar
        },
        {
            path: '/sales',
            name: 'sales',
            component: Sales
        },
        {
            path: '/ressources',
            name: 'ressources',
            component: Ressources
        },
        {
            path: '/meetingpoint',
            name: 'meetingpoint',
            component: MeetingPoint
        },
        {
            path: '/highscore',
            name: 'highscore',
            component: Highscore
        },
        {
            path: '/admin/survey',
            name: 'createSurvey',
            component: CreateSurvey
        },
        {
            path: '/admin/rooms',
            name: 'createRooms',
            component: CreateRoom
        }, {
            path: '/olddevices',
            name: 'olddevices',
            component: OldDevices
        },

        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: function() {
                return import ( /* webpackChunkName: "about" */ './views/About.vue')
            }
        },
        {
            path: '/administration',
            component: AdminBoard,
            name: "administration",
            children: [{
                    path: "",
                    component: AdminGroups
                },
                {
                    path: "groups",
                    component: AdminGroups
                },
                {
                    path: "surveys",
                    component: CreateSurvey
                },
                {
                    path: 'user',
                    component: AdminUser
                },
                {
                    path: 'createuser',
                    component: CreateUser
                },
                {
                    path: 'createvouchers',
                    component: Vouchers
                },
                {
                    path: 'announcements',
                    component: AdminAnnouncements
                },
                {
                    path: 'createressources',
                    component: CreateRessources
                },
                {
                    path: 'rooms',
                    component: CreateRoom
                },
            ]
        },
    ]
})